var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$store.getters.items),function(event){return _c('time-item',{key:event.id,attrs:{"id":event.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }